export interface BackendAlertSearch {
  incident?: string;
}

// Alert ids are UUIDs generated by the backend. Keep the URL contract narrow:
// a malformed email link must not issue an arbitrary path request or leave the
// screen looking as though it successfully selected an incident.
const ALERT_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function parseBackendAlertSearch(search: Record<string, unknown>): BackendAlertSearch {
  const incident = typeof search.incident === 'string' ? search.incident : '';
  return ALERT_ID.test(incident) ? { incident: incident.toLowerCase() } : {};
}
